import React from "react";
import MoreDetail from "./MoreDetail";
class Gift extends React.Component {
  state = {
    showDetail: false,
  };
  handleDetail = () => {
    this.setState({ showDetail: !this.state.showDetail });
  };
  render() {
    const { image, title, text, expire_time, required_points } =
      this.props.data;
    return (
      <>
        <div className="bazarcheItem">
          <img src={image} alt="itemPic" />
          <div className="bazarcheItemContainer">
            <h4>{title}</h4>
            <p>{text}</p>
            <p className="bazarcheItemDeadline">اعتبار تا {expire_time}</p>

            <div className="moreInfo">
              <span
                className="bazarcheItemMoreDetail"
                onClick={this.handleDetail}
              >
                جزییات بیشتر
              </span>
            </div>
          </div>
          <div className="bazarcheItemPoints">
            <span>
              <span>{required_points}</span>
              <img src="/public/assets/coin.svg" alt="coin" />
            </span>
          </div>
        </div>
        {this.state.showDetail && (
          <>
            <MoreDetail
              handleModalDisplay={this.handleDetail}
              detailData={this.props.data}
            />
          </>
            )}
            
      </>
    );
  }
}
export default Gift;
